import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './scss/SkeletonPage.scss';

const SkeletonPage = () => {
  return (
    <div className="skeleton-page">
      

      {/* Page Content Skeleton */}
      <div className="skeleton-content">
      

        {/* Editor Content Skeletons */}
        <div className="skeleton-editor">
          <div className="skeleton-block">
            <Skeleton width="40%" height={24} />
          </div>
          <div className="skeleton-block">
            <Skeleton count={3} height={16} />
          </div>
          <div className="skeleton-block">
            <Skeleton width="30%" height={24} />
          </div>
          <div className="skeleton-block">
            <Skeleton count={2} height={16} />
            <Skeleton width="80%" height={16} />
          </div>
          <div className="skeleton-block">
            <Skeleton height={200} borderRadius={8} />
          </div>
          <div className="skeleton-block">
            <Skeleton count={4} height={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonPage;
